import { COURSES_PRESELECTED_FILTERS } from './global/constants.js';
import { initializeDropdownSearch } from './elements/dropdown-search.js';

document.addEventListener('DOMContentLoaded', () => {
  initializeSearch();
  initializeCourseDetailFilters();
  initializeDropdownSearch();
});

const searchFormId = 'SearchFormCourseList';
const searchInputClass = 'SearchInput';
const searchResultsClass = 'CourseList__List';
const searchResultsEmptyClass = 'CourseList__List--empty';
const searchResultItemClass = 'CourseList__Item';
const searchResultItemHiddenClass = 'CourseList__Item--hidden';
const filterDropdownsClass = 'Filters__Dropdowns';
const filterCheckboxClass = 'Filters__Checkbox';
const clearButtonClass = 'Filters__Dropdown__Clear';
const filterButtonClass = 'Filters__Dropdown__Filter';
const hasActiveFilterClass = 'Filters__Dropdown--hasActiveFilter';

let $searchForm;
let $searchInput;
let $searchResults;
let $searchResultItems;
let $filterButtons;
let $clearButtons;
let searchFilters = {
  "country": {},
  "region": {},
  "q": ""
};

function initializeSearch() {
  $searchForm = document.querySelector(`#${searchFormId}`);
  $searchInput = document.querySelector(`.${searchInputClass}`);
  $searchResults = document.querySelector(`.${searchResultsClass}`);
  $searchResultItems = document.querySelectorAll(`.${searchResultItemClass}`);
  $filterButtons = document.querySelectorAll(`.${filterButtonClass}`);
  $clearButtons = document.querySelectorAll(`.${clearButtonClass}`);

  if (!$searchForm || !$searchResults || !$searchResultItems.length) {
    return;
  }

  $searchForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const query = $searchInput.value;
    searchFilters.q = query;
    filterSearchResults();
  });

  $filterButtons.forEach(($filterButton) => {
    $filterButton.addEventListener('click', (e) => {
      e.preventDefault();
      searchFilters[e.target.dataset.field] = {};
      const $filterContainer = e.target.closest('.Filters__Dropdown');
      if (e.target.dataset.field == 'region') {
        searchFilters.country = {};
        const $countryCheckboxes = document.querySelectorAll(`input[name='country']:checked`);
        if ($countryCheckboxes) {
          $countryCheckboxes.forEach($country => {
            $country.checked = false;
          });
          updateDropdownCounter(document.querySelector(`.${filterButtonClass}[data-field='country']`));
        }
      }
      const $checkboxes = $filterContainer.querySelectorAll(`.${filterCheckboxClass}:checked`);
      $checkboxes.forEach($checkbox => {
        searchFilters[$checkbox.name][$checkbox.value] = true;
      });
      updateDropdownCounter(e.target);
      filterSearchResults();
    })
  });
  $clearButtons.forEach(($clearButton) => {
    $clearButton.addEventListener('click', (e) => {
      e.preventDefault();
      searchFilters[e.target.dataset.field] = {};
      const $filterContainer = e.target.closest('.Filters__Dropdown');
      const $checkboxes = $filterContainer.querySelectorAll(`.${filterCheckboxClass}:checked`);
      $checkboxes.forEach($checkbox => {
        $checkbox.checked = false;
      });
      updateDropdownCounter(e.target);
      filterSearchResults();
    })
  });
}

function updateDropdownCounter(actionButton) {
  const closestButton = actionButton.closest('.Filters__Dropdown');
  const countContainer = closestButton.querySelector('.Filters__Dropdown__Count');
  const totalSelected = Object.keys(searchFilters[actionButton.dataset.field]).length;
  if (totalSelected === 0) {
    countContainer.textContent = "";
    closestButton.classList.remove(hasActiveFilterClass);
  } else {
    countContainer.textContent = `(${totalSelected})`;
    closestButton.classList.add(hasActiveFilterClass);
  }
}

function checkIfSearchFiltersInDataset(searchFilter, dataset) {
  if (searchFilter.hasOwnProperty(dataset)) {
    return true;
  } else {
    let filterKeys = Object.keys(searchFilter);
    for (let i = 0; i < filterKeys.length; i++) {
      if (dataset.includes(filterKeys[i])) {
        return true;
      }
    }
  }
  return false;
}

function filterSearchResults() {
  let hasResults = false;

  $searchResultItems.forEach($searchResult => {
    if (Object.keys(searchFilters.region).length > 0) {
      if (!checkIfSearchFiltersInDataset(searchFilters.region, $searchResult.dataset.region)) {
        $searchResult.classList.add(searchResultItemHiddenClass);
        return;
      }
    }

    let regionResult = false;
    if (Object.keys(searchFilters.country).length > 0) {
      if (!checkIfSearchFiltersInDataset(searchFilters.country, $searchResult.dataset.country)) {
        $searchResult.classList.add(searchResultItemHiddenClass);
        return;
      } else {
        $searchResult.classList.remove(searchResultItemHiddenClass);
        regionResult = true;
      }
    } else {
      $searchResult.classList.remove(searchResultItemHiddenClass);
      regionResult = true;
    }

    if (searchFilters.q) {
      const text = $searchResult.dataset.search;
      if (checkIfTextMatchesQuery(searchFilters.q, text)) {
        $searchResult.classList.remove(searchResultItemHiddenClass);
        hasResults = true;
      } else {
        $searchResult.classList.add(searchResultItemHiddenClass);
      }
    }

    if (regionResult && !searchFilters.q) {
      hasResults = true;
    }
  });

  if (hasResults) {
    $searchResults.classList.remove(searchResultsEmptyClass);
  } else {
    $searchResults.classList.add(searchResultsEmptyClass);
  }
}

function checkIfTextMatchesQuery(query, text) {
  query = query.trim().toLowerCase();
  if (query.length === 0) {
    return true;
  }

  text = text.toLowerCase();

  const words = query.split(/\s+/gi);
  return words.every(word => {
    const pattern = new RegExp(`\\b${word}`, 'i');
    return pattern.test(text);
  });
}

function initializeCourseDetailFilters() {
  $searchResults.addEventListener('click', (event) => {
    const $searchResult = event.target.closest(`.${searchResultItemClass}`);
    if (!$searchResult) {
      return;
    }
    const checkboxes = {
      region: [],
      country: []
    };
    if (localStorage.getItem(COURSES_PRESELECTED_FILTERS)) {
      localStorage.removeItem(COURSES_PRESELECTED_FILTERS);
    }
    const $filterDropdowns = document.querySelector(`.${filterDropdownsClass}`);
    const $checkboxes = $filterDropdowns.querySelectorAll(`.${filterCheckboxClass}:checked`);
    if ($checkboxes.length === 0) {
      return;
    }
    $checkboxes.forEach($checkbox => {
      const name = $checkbox.name;
      if (checkboxes.hasOwnProperty(name)) {
        checkboxes[name].push($checkbox.defaultValue);
      }
    });
    localStorage.setItem(COURSES_PRESELECTED_FILTERS, JSON.stringify(checkboxes));
  });
}
